module.exports = __webpack_public_path__ + "img/8.a28ea4cf.png";